import React from 'react';

import ModalBase from './ModalBase';
import ModalHeader from './ModalHeader';
import ModalContent from './ModalContent';
import TModalBase from './@types/TModalBase';
import TModalHeader from './@types/TModalHeader';
import TBasicModal from './@types/TBasicModal';

const BasicModal = ({
  title,
  label,
  children,
  onClose,
  onBack,
  onLabelClick,
  contentClassName,
  isBottomSheet,
  headerAction,
  ...rest
}: TModalBase & TModalHeader & TBasicModal) => (
  <ModalBase kind={isBottomSheet ? 'bottom-sheet' : 'basic'} onClose={onClose} {...rest}>
    <ModalHeader
      headerAction={headerAction}
      onClose={onClose}
      title={title}
      onBack={onBack}
      label={label}
      onLabelClick={onLabelClick}
    />
    <ModalContent className={contentClassName}>{children}</ModalContent>
  </ModalBase>
);

export default BasicModal;
